import React from 'react';
import Icon from '../../../../components/AppIcon';

const WorkDurationSummary = ({ punchInTime, currentTime }) => {
  const formatTime = (date) => {
    return new Date(date)?.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const calculateDuration = () => {
    if (!punchInTime || !currentTime) return { hours: 0, minutes: 0, seconds: 0, total: 0 };
    const diff = currentTime - new Date(punchInTime);
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    return { hours, minutes, seconds, total: diff };
  };

  const duration = calculateDuration();

  const formatDurationText = () => {
    if (duration?.hours > 0) {
      return `${duration?.hours}h ${duration?.minutes}m`;
    }
    return `${duration?.minutes}m ${duration?.seconds}s`;
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-xl shadow-elevation-2 p-4 md:p-6 border border-primary/20">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/20 flex items-center justify-center">
          <Icon name="Clock" size={20} className="md:w-6 md:h-6 text-primary" />
        </div>
        <div>
          <h2 className="text-base md:text-lg font-semibold text-foreground">Total Work Duration</h2>
          <p className="text-xs md:text-sm text-muted-foreground">Your session summary</p>
        </div>
      </div>
      <div className="text-center py-4 md:py-6">
        <div className="text-4xl md:text-6xl font-bold text-primary mb-2">
          {String(duration?.hours || 0).padStart(2, '0')}:{String(duration?.minutes || 0).padStart(2, '0')}:{String(duration?.seconds || 0).padStart(2, '0')}
        </div>
        <p className="text-sm md:text-base text-muted-foreground">{formatDurationText()}</p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:gap-4 mt-4 md:mt-6">
        <div className="bg-card/50 backdrop-blur-sm rounded-lg p-3 md:p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="LogIn" size={16} className="text-primary md:w-5 md:h-5" />
            <p className="text-xs md:text-sm text-muted-foreground">Start Time</p>
          </div>
          <p className="text-sm md:text-base font-semibold text-foreground">
            {punchInTime ? formatTime(punchInTime) : 'N/A'}
          </p>
        </div>

        <div className="bg-card/50 backdrop-blur-sm rounded-lg p-3 md:p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="LogOut" size={16} className="text-primary md:w-5 md:h-5" />
            <p className="text-xs md:text-sm text-muted-foreground">End Time</p>
          </div>
          <p className="text-sm md:text-base font-semibold text-foreground">{formatTime(currentTime)}</p>
        </div>
      </div>
      {punchInTime && (
        <div className="mt-4 md:mt-6 p-3 md:p-4 bg-card/50 backdrop-blur-sm rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} className="text-muted-foreground md:w-5 md:h-5" />
              <p className="text-xs md:text-sm text-muted-foreground">Date</p>
            </div>
            <p className="text-sm md:text-base font-medium text-foreground">
              {new Date(punchInTime)?.toLocaleDateString('en-US', { 
                month: 'short', 
                day: 'numeric', 
                year: 'numeric' 
              })}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkDurationSummary;


